import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-layout-third",
  "use": "svg-icon-layout-third-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"svg-icon-layout-third\"><path d=\"M7.628 17.456H5.781a.923.923 0 01-.923-.923V6.374c0-.51.414-.923.923-.923h1.847v12.005M9.474 5.451h2.769V17.44H9.474V5.451zm4.615 0h1.846c.51 0 .923.413.923.923v10.159c0 .51-.413.923-.923.923h-1.846V5.451\" fill=\"#CAD4D8\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol